import { styled } from 'goober';

const Button = styled('button')`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.05);
    color: var(--text);
  }
`;

interface CollapseButtonProps {
  collapsed: boolean;
  onClick: () => void;
  panelId?: string;
}

export function CollapseButton({ collapsed, onClick }: CollapseButtonProps) {
  return (
    <Button
      data-testid="panel-collapse"
      title={collapsed ? 'Afficher' : 'Masquer'}
      onClick={onClick}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {collapsed ? (
          <polyline points="6 9 12 15 18 9"></polyline>
        ) : (
          <polyline points="18 15 12 9 6 15"></polyline>
        )}
      </svg>
    </Button>
  );
}
